import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { clearPendingAuthorizationOutsideConsent } from '@/lib/mcp-consent';
import { useAuthStore } from '@/stores/auth';
import { SessionRestoring, SessionUnavailable } from './SessionGate';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const accessToken = useAuthStore((s) => s.accessToken);
  const sessionStatus = useAuthStore((s) => s.sessionStatus);
  const { pathname } = useLocation();
  if (accessToken) return <>{children}</>;
  // O access só vive em memória: ao carregar a página, a decisão espera a renovação pelo cookie
  // (`bootstrapSession`), e a falha passageira dela não é falta de sessão.
  if (sessionStatus === 'restoring') return <SessionRestoring />;
  if (sessionStatus === 'unavailable') return <SessionUnavailable />;
  // Sem sessão numa página comum, o login não é a volta a um pedido do agente: a query
  // pendente do consentimento sai, e o próximo login segue para /tenants.
  clearPendingAuthorizationOutsideConsent(pathname);
  return <Navigate to="/login" replace />;
}
